import { Component, OnInit } from '@angular/core';
import { EditStudentService } from '../edit-student.service';
import { LoginUserService } from '../../../core/services/login-user.service';
import { MessageService } from '../../../core/services/message.service';

export interface SearchOption {
  isbind: boolean;
  name: string;
  type: string;
  value: string;
  title: string;
  label: string;
  code: string;
}

@Component({
  selector: 'app-user-bind',
  templateUrl: './user-bind.component.html',
  styleUrls: ['./user-bind.component.scss']
})
export class UserBindComponent implements OnInit {
  public formData: SearchOption[] = [
    { isbind: false, name: '手机号：', type: 'phone', value: null, title: "手机号绑定", label: "我的手机号", code: "手机验证码" },
    { isbind: false, name: '邮箱：', type: 'email', value: null, title: "邮箱绑定", label: "我的邮箱", code: "邮箱验证码", },
    { isbind: false, name: '微信：', type: 'weixin', value: null, title: "微信号绑定", label: "我的微信号", code: "微信验证码", },
    { isbind: false, name: '腾讯QQ：', type: 'QQ', value: null, title: "QQ号绑定", label: "我的QQ号", code: "QQ验证码", },
    { isbind: false, name: '新浪微博：', type: 'weibo', value: null, title: "新浪微博号绑定", label: "我的新浪微博号", code: "微博验证码", }
  ]; //用户绑定信息
  public phoneType: boolean = false;//电话
  public isDisplay: boolean = false;//模态框闭合
  public activeItem: SearchOption;//操作的单条数据
  constructor(
    private _eidtStuService: EditStudentService,
    private _login: LoginUserService,
    private _msg: MessageService
  ) { }
  ngOnInit() {
    //获取用户绑定信息
    this.getBingData();
  }
  isSuccess(event) {
    if (event) {
      //获取用户绑定信息
      this.getBingData();
    }
  }
  //bind open bindmodal
  bindAccount(event) {
    let cc = 0;
    this.formData.map(rec => {
      rec.isbind ? cc++ : cc;
    })
    this.activeItem = this.formData.find(rec => rec.type === event);
    if (this.activeItem.isbind) {
      if (cc <= 1) {
        this._msg.info("不能解除绑定！");
        return false;
      }
    }
    this.isDisplay = true;
  }
  //close bindmodal
  closeDisplay() {
    this.isDisplay = false;
  }
  //获取用户绑定信息
  getBingData() {
    this._eidtStuService.getStudentBindData().then(resp => {
      if (resp.success) {
        let cc = Object.keys(resp['data']);
        this.formData.map(rec => {
          if (resp['data'][rec.type] && resp['data'][rec.type] !== "0") {
            rec.isbind = true;
            rec.value = resp['data'][rec.type];
          }
        });
      }
    })
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user-info/edit-student/user-bind/user-bind.component.ts